import { Select, SelectProps } from "antd";
import { useMemo } from "react";
import color from "../../../theme/color";
import { ArrowChevronDown, GhostSearch, InterfaceCheck } from "../Icon";
import { IconForm } from "../Icon/index.styled";

/**
 * 아이콘 커스텀 셀렉트박스
 * @param param0
 * @returns
 */
export const CustomSelect: React.FC<SelectProps> = ({ style, ...props }) => {
  /**
   * size에 따른 높이 조절
   * @notice  antdTheme.less 로 기본 작업해야하나.. 찾을 수없어 강제 주입
   */
  const height = useMemo(() => {
    switch (props.size) {
      case "large":
        return 44;
      case "small":
        return 32;
      default:
        return 36;
    }
  }, [props.size]);

  return (
    <Select
      {...props}
      suffixIcon={<IconForm component={ArrowChevronDown} color={color.gray4} />}
      menuItemSelectedIcon={
        <IconForm
          component={InterfaceCheck}
          color={color.primary3}
          style={{ fontSize: 16 }}
        />
      }
      style={{ height, ...style }}
    />
  );
};
